import * as ko from "knockout";
import entityBase from "entityBase";

export class TfaSettings extends entityBase {
  //
  k_access_group: KnockoutObservable<string>;
  grace_period_start_date: KnockoutObservable<Date>;
  grace_period_end_date: KnockoutObservable<Date>;
  is_active: KnockoutObservable<boolean>;

  user_tfa_code: KnockoutObservable<string>;

  restrictUser: KnockoutComputed<boolean>;

  constructor(item?: any) {
    super();

    this.k_access_group = ko.observable(item?.k_access_group);
    this.grace_period_start_date = ko.observable(this.formatJSONDate(item?.grace_period_start_date));
    this.grace_period_end_date = ko.observable(this.formatJSONDate(item?.grace_period_end_date));
    this.is_active = ko.observable(item?.is_active ?? false);
    this.user_tfa_code = ko.observable(item?.user_tfa_code);

    this.restrictUser = ko.computed(() => {
      const expiredGrace = new Date() > this.grace_period_end_date();

      return this.is_active() && !this.user_tfa_code() && expiredGrace;
    });
  }
}
